import React from "react";
import { Section, FadeUp, SectionHeading, CheckItem, CtaButton } from "./primitives";
import { outcomes } from "@/data/content";

export const Outcomes = () => (
  <Section className="bg-zinc-100">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>How To Actually Reach An Advanced Level On Guitar</SectionHeading>
        <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed">
          I've spent years working out exactly what separates players who break through from players who stay
          stuck, so you don't have to guess.
        </p>
        <p className="mt-4 text-lg md:text-xl font-bold text-zinc-900">
          Apply for a place today so you can:
        </p>
      </FadeUp>
      <FadeUp delay={0.05}>
        <ul className="mt-12 grid gap-x-10 gap-y-5 md:grid-cols-2 max-w-[980px] mx-auto">
          {outcomes.map((item) => (
            <CheckItem key={item}>{item}</CheckItem>
          ))}
        </ul>
      </FadeUp>
      <FadeUp delay={0.1}>
        <div className="mt-14 flex justify-center">
          <CtaButton testid="cta-outcome-apply" />
        </div>
      </FadeUp>
    </div>
  </Section>
);
